import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventMantenedorRelatorService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    refreshTable() {
        this.invokeFirstComponentFunction.emit();
    }
}
EventMantenedorRelatorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventMantenedorRelatorService_Factory() { return new EventMantenedorRelatorService(); }, token: EventMantenedorRelatorService, providedIn: "root" });
